import React, { Fragment, useState } from 'react';
import { useMediaQuery } from '../../../libs';
import { PromotionPackageServices } from '../../../libs/flashSales';

export const PromPackagesSaleBar = ({ onClick, promPackagesSale }) => {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const [visible, setIsVisible] = useState(true);

  if (!visible) return null;

  const promotions = promPackagesSale?.package_services?.reduce((acc, item) => {
    const promotion = PromotionPackageServices.find((p) => p.id === item.service.prom_service_id);
    if (promotion) {
      acc.push(promotion);
    }
    return acc;
  }, [])

  return (
    <div
      className={'text-white'}
      style={{
        background: '#222',
        position: 'relative',
        maxHeight: isMobile ? '64px' : '40px',
        padding: '8px 0',
        cursor: 'pointer',
        width: '100%',
        fontSize: '14px',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: 'center',
        gap: isMobile ? '4px' : '12px',
      }}
      onClick={onClick}
    >
      <div style={{ display: 'flex', alignItems: 'center', }}>
        {promotions?.map((promotion) => (
          <Fragment key={promotion.id}>
            <span
              style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: promotion?.bgColor,
                border:'2px solid white',
                marginLeft:'-6px'
              }}
            >
              <i className={`svg-i ${promotion.iconName}`} style={{ position: 'relative', fontStyle: 'normal', width: '16px', height: '16px' }}></i>
            </span>
          </Fragment>
        ))}
      </div>
      <div style={{ width: '1px', background: '#3D3F4B', height: '16px', display: isMobile ? 'none' : 'block' }}></div>
      <div className={'font-medium'} style={{ display: 'flex', alignItems: 'center' }}>
        {promPackagesSale?.lang_data?.title}
        <i className={'svg-i arrow-forward'} style={{ display: isMobile ? 'inline-block' : 'none', marginLeft: '4px' }} />
      </div>
      <span className={'font-base'} style={{ textDecoration: 'underline', fontSize: '12px', color: '#d4d4d7', display: isMobile ? 'none' : 'block' }}>
        გაიგე მეტი
      </span>
      <i
        className={'svg-i flash-sale-bar-close'}
        onClick={(e) => {
          e.stopPropagation();
          sessionStorage.setItem('PromPackageSaleBarClosed', 'true');
          setIsVisible(false);
        }}
        style={{ position: 'absolute', right: '24px', top:  isMobile ? '30%' :'50%', transform: 'translateY(-50%)' }}
      ></i>
    </div>
  );
};
